import React from 'react';
import { Button } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { useDispatch } from 'react-redux';
import { Order } from '@api/Orders/Order';
import { setActivityDrawer } from '@store/appStore';
import { buildOrderTimeline } from '@api/Orders/OrderActivity';

interface OrderActivityButtonProps {
    order?: Order;
}

/**
 * El botón "Actividad" de un pedido: abre su bitácora. Es el MISMO en el detalle
 * de `/orders` y en `ModalViewOrder`.
 *
 * En el modal **faltaba** (M1 del plan): es donde un admin investiga un pedido
 * viejo —desde el Dashboard y desde el historial de puntos del cliente—, y era
 * el único punto de investigación sin la puerta. El de la lista ya existía.
 *
 * Le pasa además los renglones DERIVADOS del propio pedido (D8): *"Pedido
 * recibido"*, *"Pagado con tarjeta por el cliente (Stripe)"* y *"Entregado por
 * Uber"* — lo que pasó FUERA del admin y por eso no tiene renglón propio. **Solo
 * el admin escribe `activity-logs`**, así que sin ellos un pedido de la web abría
 * su bitácora con cero o un renglón, aunque el documento supiera perfectamente lo
 * que le había pasado. No cuestan ni una lectura: salen del pedido que la
 * pantalla ya tiene en memoria.
 */
const OrderActivityButton: React.FunctionComponent<OrderActivityButtonProps> = ({ order }) => {
    const dispatch = useDispatch();

    const onOpenActivity = () => {
        if (!order?.id) return;
        dispatch(
            setActivityDrawer({
                isOpen: true,
                section: 'orders',
                sectionId: order.id,
                derived: buildOrderTimeline(order)
            })
        );
    };

    return (
        <Button variant="outlined" startIcon={<PriorityHighIcon />} onClick={onOpenActivity}>
            Actividad
        </Button>
    );
};

export default OrderActivityButton;
